import { render } from "./StyledInput.vue?vue&type=template&id=5879107c&scoped=true"
import script from "./StyledInput.vue?vue&type=script&lang=js"
export * from "./StyledInput.vue?vue&type=script&lang=js"

import "./StyledInput.vue?vue&type=style&index=0&id=5879107c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5879107c"]])

export default __exports__